export default "__VITE_ASSET__fCr$uagX__"